import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';
import { parsePatientIdFromUrl } from './utils/parsePatientIdFromUrl';
import { setRiskGapAnswer } from './utils/setRiskGapAnswer';
import { PatientCacheRef, PatientServiceEvents } from './usePatientService';

export const useRiskGapResponse = (events: PatientServiceEvents, patientCache: PatientCacheRef) => {
    const services = React.useContext(ServicesContext);

    const riskGapResponse = useCallback(
        async (
            gapId: number,
            answer: boolean,
            updatedAt: string | null,
            options?: ApiRequestOptionsType
        ) => {
            const result: ApiDataResponseType<RiskGapType & { patient: string }> =
                await services.api.call(
                    {
                        method: 'put',
                        url: `/api/risk-gaps/${gapId}`,
                        data: {
                            submission_answer: {
                                answer: answer === true ? 1 : 2,
                            },
                            updated_at: updatedAt,
                        },
                    },
                    options
                );

            const patientId = parsePatientIdFromUrl(result.data.patient);
            if (patientId !== undefined && patientCache.current[patientId]) {
                patientCache.current[patientId].risk_gaps.forEach((x, i, a) => {
                    if (x.id === gapId) {
                        a[i] = setRiskGapAnswer(result.data);
                    }
                });
            }

            services.events.publish(events.risk_gap_response);
            services.events.publish(events.patient_updated);
        },
        [services.api, services.events, events, patientCache]
    );

    return riskGapResponse;
};
